export default {"src":"/_next/static/media/watch-filled.7a1c65fd.svg","height":16,"width":20};